import React, { useState } from "react";
import PracticeMode from "./Modes/PracticeMode.js";
import TestMode from "./Modes/TestMode.js";
import CompetitiveMode from "./Modes/CompetitiveMode";
import ScoresMode from "./Modes/ScoresMode";
import HighScoresMode from "./Modes/HighScoresMode";
import "../styles/Tabs.css"; // Styles for the tabs

const Tabs = () => {
  const [activeTab, setActiveTab] = useState("practice"); // Default tab

  return (
    <div className="tabs-container">
      <div className="tabs-spacer-top"></div>
      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={`tab ${activeTab === "practice" ? "active" : ""}`}
          onClick={() => setActiveTab("practice")}
        >
          PRACTICE
        </button>
        <button
          className={`tab ${activeTab === "competitive" ? "active" : ""}`}
          onClick={() => setActiveTab("competitive")}
        >
          RANKED
        </button>
        <button
          className={`tab ${activeTab === "scores" ? "active" : ""}`}
          onClick={() => setActiveTab("scores")}
        >
          HISTORY
        </button>
        <button
          className={`tab ${activeTab === "highscores" ? "active" : ""}`}
          onClick={() => setActiveTab("highscores")}
        >
          HIGH SCORES
        </button>
        {/* <button
          className={`tab ${activeTab === "settings" ? "active" : ""}`}
          onClick={() => setActiveTab("settings")}
        >
          Settings
        </button> */}
      </div>

      {/* <div className="tabs-spacer-bottom"></div> */}

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "practice" && <PracticeMode />}
        {activeTab === "competitive" && <CompetitiveMode />}
        {activeTab === "settings" && <h2>Settings Coming Soon!</h2>}
        {activeTab === "test" && <TestMode />}
        {activeTab === "scores" && <ScoresMode />}
        {activeTab === "highscores" && <HighScoresMode />}
      </div>
    </div>
  );
};

export default Tabs;
